import { UpOutlined } from '@ant-design/icons';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';

const ScrollToTop = () => {
  const [showTopBtn, setShowTopBtn] = useState(false);
  useEffect(() => {
    document.body.addEventListener('scroll', () => {
      if (document.body.scrollTop > 1500) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    });
  }, []);
  const goToTop = () => {
    document.body.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <div className={clsx('relative', showTopBtn ? 'opacity-100' : 'opacity-0')}>
      <UpOutlined
        onClick={goToTop}
        className='fixed bottom-[40px] right-[25px] z-20 flex h-12 w-12 cursor-pointer items-center justify-center rounded-full border-2 border-purple-800 bg-white text-purple-800 transition-all duration-500 ease-in-out'
      />
    </div>
  );
};
export default ScrollToTop;
